import { Router, Utils, Log } from '@lightningjs/sdk'
import Loader from './components/Loader'
import routes from './lib/Routes'
import * as widget from './widgets/index'

export default class App extends Router.App {
  static getFonts() {
    return [
      { family: 'OpenSansLight', url: Utils.asset('fonts/OpenSans-Light.ttf') },
      { family: 'OpenSansRegular', url: Utils.asset('fonts/OpenSans-Regular.ttf') },
      { family: 'OpenSansBold', url: Utils.asset('fonts/OpenSans-Bold.ttf') },
      { family: 'OpenSansSemibold', url: Utils.asset('fonts/OpenSans-SemiBold.ttf') },
    ]
  }

  static language() {
    return {
      file: Utils.asset('translations/translations.json'),
      language: 'en',
    }
  }

  static colors() {
    return Utils.asset('colors.json')
  }

  static _template() {
    return {
      Pages: { forceZIndexContext: true },
      Widgets: {
        zIndex: 98,
        SideMenu: { type: widget.SideMenu },
        ErrorBox: { type: widget.ErrorBox, alpha: 0 },
        GlobalPlayer: { type: widget.GlobalPlayer },
      },
      Loading: {
        visible: false,
        zIndex: -99,
        Loader: { type: Loader },
      },
    }
  }

  _setup() {
    this.stage._options.defaultFontFace = 'OpenSansRegular'

    routes.stage(this.stage)
    Router.startRouter(routes, this)
  }

  get pages() {
    return this.tag('Pages')
  }

  get widgets() {
    return this.tag('Widgets')
  }

  _handleBack(e) {
    Log.info('App:HandleBack')
    Router.step(-1)
    e.preventDefault()
    e.stopPropagation()
  }

  _handleAppClose() {
    Log.info('App:AppClose')
    this.tag('GlobalPlayer').closeWebSocket(true)
    this.application.closeApp()
    window.close()
  }

  _getFocused() {
    return Router.getActivePage()
  }

  static _states() {
    return [
      class Loading extends this {
        $enter() {
          this.tag('Loading').patch({
            visible: true,
            zIndex: 99,
            Loader: { alpha: 1 },
          })
        }

        $exit() {
          this.tag('Loading').patch({
            visible: false,
            zIndex: -99,
            Loader: { alpha: 0 },
          })
        }
      },

      class Widgets extends this {
        $enter(args, widget) {
          this._widget = widget

          this._refocus()
        }

        reload(widget) {
          this._widget = widget

          this._refocus()
        }

        _getFocused() {
          return this._widget
        }
      },
    ]
  }
}
